/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BookingIdRemarkRuleListItem,
    BookingIdRemarkRuleListItemFromJSON,
    BookingIdRemarkRuleListItemFromJSONTyped,
    BookingIdRemarkRuleListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface BookingIdRemarkRuleListItemPaginationWrapper
 */
export interface BookingIdRemarkRuleListItemPaginationWrapper {
    /**
     * 
     * @type {Array<BookingIdRemarkRuleListItem>}
     * @memberof BookingIdRemarkRuleListItemPaginationWrapper
     */
    items?: Array<BookingIdRemarkRuleListItem> | null;
    /**
     * 
     * @type {number}
     * @memberof BookingIdRemarkRuleListItemPaginationWrapper
     */
    totalItems?: number;
}

export function BookingIdRemarkRuleListItemPaginationWrapperFromJSON(json: any): BookingIdRemarkRuleListItemPaginationWrapper {
    return BookingIdRemarkRuleListItemPaginationWrapperFromJSONTyped(json, false);
}

export function BookingIdRemarkRuleListItemPaginationWrapperFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingIdRemarkRuleListItemPaginationWrapper {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(BookingIdRemarkRuleListItemFromJSON)),
        'totalItems': !exists(json, 'totalItems') ? undefined : json['totalItems'],
    };
}

export function BookingIdRemarkRuleListItemPaginationWrapperToJSON(value?: BookingIdRemarkRuleListItemPaginationWrapper | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(BookingIdRemarkRuleListItemToJSON)),
        'totalItems': value.totalItems,
    };
}


